import {IUserProfile} from "../types/IUserProfile";

export const checkHasName = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile?.name);
};
import {IUserProfile} from "../types/IUserProfile";

export const checkHasName = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile?.name);
};
